import React, { FC } from 'react';
import Application from './Application';

const CallCenter: FC = () => <Application isCallCenter />;

export default CallCenter;
